import AppHeader from "@components/app-header";
import MultipleCommunitySelector from "@components/common/multiple-community-selector";
import { PeekGrid, PeekStack, useTheme } from "@piiqtechnologies/ui-components";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Outlet } from "react-router-dom";
import { messages } from "./messages.i18n";
import { useAuthContext } from "@stores/AuthContext";
export const ProspectIntelligenceLayout = () => {
    var _a;
    const intl = useIntl();
    const theme = useTheme();
    const { user } = useAuthContext();
    const [layoutConfig, setLayoutConfig] = useState({
        communitySelect: false,
        pageTitle: "",
        backButton: false,
    });
    const [selectedCommunities, setSelectedCommunities] = useState([]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(PeekGrid, { container: true, direction: "row", spacing: 1, justifyContent: "space-between" },
                React.createElement(PeekGrid, { item: true, xs: 8 },
                    React.createElement(PeekStack, { direction: "row", spacing: 4, alignItems: "center" },
                        React.createElement(AppHeader, { headerLabel: layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.pageTitle, backButton: layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.backButton, onBackButtonClick: layoutConfig.onBack }),
                        React.createElement(PeekStack, { direction: "row", spacing: theme.spacing(1), flexGrow: 1, maxWidth: "fit-content", minHeight: theme.spacing(4) }, (layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.communitySelect) && !!((_a = user === null || user === void 0 ? void 0 : user.communities) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement(MultipleCommunitySelector, { feature: "Analytics" /* PolicyActions.ANALYTICS */, placeholder: !(selectedCommunities === null || selectedCommunities === void 0 ? void 0 : selectedCommunities.length)
                                ? intl.formatMessage(messages.communitySelectorPlaceholder)
                                : intl.formatMessage(messages.communitySelectorPlaceholderAddMore), communities: user.communities, selectedCommunities: selectedCommunities, onSelectionChange: setSelectedCommunities }))))),
                React.createElement(PeekGrid, { item: true }))),
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(Outlet, { context: { setLayoutConfig, selectedCommunities } }))));
};
